import { baseApi } from "./baseApi";

const VEHICLE_HIRING_ENTRY_BASE_URL = "/vehicle-hiring-entry";

export const vehicleHiringEntryApi = baseApi.injectEndpoints({
  tagTypes: ["VehicleHiringEntry"],
  endpoints: (build) => ({
    addVehicleHiringEntry: build.mutation({
      query: (body) => ({
        url: VEHICLE_HIRING_ENTRY_BASE_URL,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "VehicleHiringEntry", id: "LIST" }],
    }),
    listVehicleHiringEntries: build.query({
      query: (params) => ({
        url: VEHICLE_HIRING_ENTRY_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "VehicleHiringEntry",
                id: _id,
              })),
              { type: "VehicleHiringEntry", id: "LIST" },
            ]
          : [{ type: "VehicleHiringEntry", id: "LIST" }],
    }),
    getVehicleHiringEntryDetail: build.query({
      query: (id) => `${VEHICLE_HIRING_ENTRY_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "VehicleHiringEntry", id },
        { type: "VehicleHiringEntry", id: "LIST" },
      ],
    }),
    updateVehicleHiringEntry: build.mutation({
      query: ({ id, ...body }) => ({
        url: `${VEHICLE_HIRING_ENTRY_BASE_URL}/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "VehicleHiringEntry", id },
        { type: "VehicleHiringEntry", id: "LIST" },
      ],
    }),
    reviewVehicleHiringEntry: build.mutation({
      query: ({ id, ...body }) => ({
        url: `${VEHICLE_HIRING_ENTRY_BASE_URL}/${id}/review`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "VehicleHiringEntry", id },
        { type: "VehicleHiringEntry", id: "LIST" },
      ],
    }),
    resubmitVehicleHiringEntry: build.mutation({
      query: ({ id, ...body }) => ({
        url: `${VEHICLE_HIRING_ENTRY_BASE_URL}/${id}/resubmit`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "VehicleHiringEntry", id },
        { type: "VehicleHiringEntry", id: "LIST" },
      ],
    }),
    markVehicleHiringEntryAttendance: build.mutation({
      query: ({ id, ...body }) => ({
        url: `${VEHICLE_HIRING_ENTRY_BASE_URL}/${id}/attendance`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "VehicleHiringEntry", id },
      ],
    }),
    getVehicleHiringEntryChangeLog: build.query({
      query: ({ id, ...params }) => ({
        url: `${VEHICLE_HIRING_ENTRY_BASE_URL}/${id}/changelog`,
        params,
      }),
      providesTags: (result, error, { id }) => [
        { type: "VehicleHiringEntry", id: `${id}-CHANGELOG` },
      ],
    }),
    withdrawVehicleHiringEntry: build.mutation({
      query: (id) => ({
        url: `${VEHICLE_HIRING_ENTRY_BASE_URL}/${id}/withdraw`,
        method: "PUT",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "VehicleHiringEntry", id },
        { type: "VehicleHiringEntry", id: "LIST" },
      ],
    }),
  }),
  overrideExisting: false,
});
export const {
  useListVehicleHiringEntriesQuery,
  useLazyListVehicleHiringEntriesQuery,
  useAddVehicleHiringEntryMutation,
  useGetVehicleHiringEntryDetailQuery,
  useUpdateVehicleHiringEntryMutation,
  useReviewVehicleHiringEntryMutation,
  useResubmitVehicleHiringEntryMutation,
  useMarkVehicleHiringEntryAttendanceMutation,
  useGetVehicleHiringEntryChangeLogQuery,
  useLazyGetVehicleHiringEntryChangeLogQuery,
  useWithdrawVehicleHiringEntryMutation,
} = vehicleHiringEntryApi;
